const prefix = "contractor-";

export default function contractorUid(contractorId) {
	return `${prefix}${contractorId}`;
}

export function isContractorUid(uid) {
	return typeof uid === "string" && uid.startsWith(prefix);
}
